import { render, staticRenderFns } from "./PageBackBar.vue?vue&type=template&id=f40e3138&"
import script from "./PageBackBar.vue?vue&type=script&lang=ts&"
export * from "./PageBackBar.vue?vue&type=script&lang=ts&"
import style0 from "./PageBackBar.vue?vue&type=style&index=0&lang=postcss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
installComponents(component, {VAppBar})
